export default __webpack_public_path__ + "static/media/swedan.437809b2.png";